import React from 'react'
import Switch from '@material-ui/core/Switch'

export const SwitchUnstyled = ({ className, input = {}, ...others }) => {
  // backwards compatibility
  var value = 'value' in others ? others.value : input.value
  return (
    <div className={className}>
      <Switch checked={value} {...input} {...others} />
      <label htmlFor={others.id}>{others.label || ''}</label>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Form/Switch/unstyled.js